import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import makeTheme from '~/assets/styles/makePrimaryColorTheme';

import Typography from '@material-ui/core/Typography';
import { ThemeProvider } from '@material-ui/styles';

function Text(props){
  const {color, children, ...ownProps} = props;
  const theme = useMemo(() => makeTheme(color));

  return(
    <ThemeProvider theme={theme}>
      <Typography
        {...ownProps}
        color='primary'
      >
        {children}
      </Typography>
    </ThemeProvider>
  );
}

Text.propTypes = {
  color: PropTypes.string,
  className: PropTypes.node,
};

export default Text;
